import h from 'react-hyperscript';
import portable from '../../assets/icons/location-portable.svg';
import bAndM from '../../assets/icons/location.svg';

const VenueLocationIcon = ({ isPortable, ...props }) =>
  h('img.location-type', { src: isPortable ? portable : bAndM, ...props });

export default VenueLocationIcon;



// WEBPACK FOOTER //
// ./src/components/VenueLocations/VenueLocationIcon.js